import {IRunFile} from '../../../incase-domain/proptypes/runfile';

export const UPDATE_PRESENTATION_RUN_FILE = 'UPDATE_PRESENTATION_RUN_FILE';
export const SAVE_PRESENTATION_RUN_FILE = 'SAVE_PRESENTATION_RUN_FILE';
export const REMOVE_CURRENT_SLIDE_DRAWING = 'REMOVE_CURRENT_SLIDE_DRAWING';
export const RESET_RUNFILE = 'RESET_RUNFILE';

export interface ISavePresentationRunFileActionType {
    type: typeof SAVE_PRESENTATION_RUN_FILE;
    runFile: IRunFile;
}

export interface IRemoveCurrentSlideDrawingAction {
    type: typeof REMOVE_CURRENT_SLIDE_DRAWING;
}

export interface IUpdatePresentationRunFileAction {
    type: typeof UPDATE_PRESENTATION_RUN_FILE;
    runFile: IRunFile;
}

export interface IResetRunfile {
    type: typeof RESET_RUNFILE;
}

export type RunfileReducerType = IUpdatePresentationRunFileAction | IResetRunfile;
